// extracted by mini-css-extract-plugin
export var closeButton = "bJ_fr";
export var dialogWrapper = "bJ_fs";
export var mainContent = "bJ_T";
export var modalWrapper = "bJ_fq";